import React from "react";
import {
  ASSIST_ROUND_BUTTONS,
  ASSIST_ROUND_GROUPS,
  groupRoundButtons,
} from "../../config/admissionRound";
import { attachRoundMeta } from "./quotaRounds";
import RoundImageRows from "./RoundImageRows";
import RoundCaption from "./RoundCaption";

/* ---------------------------------------------------------------------------
 * รูปปุ่มชั่วคราว — ยืมของภาคปกติ (/Register/1) มาใช้ก่อนระหว่างรอนักออกแบบ
 *
 * เมื่อได้ไฟล์จริงแล้วให้วางที่ src/assets/2027/assist/ แล้วแก้ import ล่างนี้
 * สเปกไฟล์: PNG พื้นโปร่ง 1024 x 512 px (สัดส่วน 2:1) — CSS ย่อให้กว้างสุด 300 px
 *
 * key ของรูปต้องตรงกับ key ใน ASSIST_ROUND_BUTTONS
 * ------------------------------------------------------------------------- */
import rob1 from "../../assets/2027/normall/rob1.png";
import rob2 from "../../assets/2027/normall/rob2.png";
import rob3 from "../../assets/2027/normall/rob3.png";

const IMAGES = { arob1: rob1, arob2: rob2, arob3: rob3 };

/**
 * ประกาศนียบัตรบัณฑิต สาขาผู้ช่วยพยาบาล — /Register/0
 * เปิด-ปิดปุ่มแก้ที่ ASSIST_ROUND_BUTTONS ใน config/admissionRound.js
 * ส่วนวันรับสมัครใต้ปุ่มดึงจาก API ตาม ROB_ID
 */
function AssistantNurseRounds({ rounds, selectedRobId, onSelect }) {
  const groups = attachRoundMeta(
    groupRoundButtons(ASSIST_ROUND_BUTTONS, ASSIST_ROUND_GROUPS, IMAGES),
    rounds
  );

  if (groups.length === 0) {
    return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }

  return (
    <RoundImageRows
      groups={groups}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
      renderCaption={(round) => <RoundCaption round={round} />}
    />
  );
}

export default AssistantNurseRounds;
